export class Entitytag {
    tagId:string;
    title:string;
    tagtype:string;
    entityId:string;
    creator?:string;
    created?:string;
    organizationId:string;
    organizationname:string;
}